import { useEffect } from "react";

const useStickyClass = (ref: React.RefObject<HTMLElement>, activeClass: string) => {
  useEffect(() => {
    if (!ref.current) return;

    const el = ref.current;
    const classes = activeClass.split(" ");

    const handleScroll = () => {
      if (!el) return;
      const computedTop = parseInt(window.getComputedStyle(el).top, 10) || 0; // Obtener el valor numérico de 'top' asignado al elemento en estilos
      const rect = el.getBoundingClientRect();
      if (rect.top <= computedTop) {
        classes.forEach(cls => el.classList.add(cls));
      } else {
        classes.forEach(cls => el.classList.remove(cls));
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [ref.current, activeClass]);
};

export default useStickyClass;


/* 
  Hook personalizado para agregar o quitar clases CSS a un elemento cuando se desplaza la página.
  El hook toma una referencia a un elemento y una cadena de clases CSS.
  Cuando el usuario se desplaza y el elemento alcanza la parte superior de la ventana (considerando su propiedad 'top' en CSS), 
  las clases especificadas se agregan al elemento. Si el usuario se desplaza hacia arriba y el elemento ya no está en la parte superior, 
  las clases se eliminan.

  Uso:
    const ref = useRef<HTMLElement>(null);
    useStickyClass(ref, "fixed top-0 bg-white shadow-lg");

  Daniel Bonilla - Septiembre 2025
*/